export default {
  CustomerModel() {
    return {
      id: '',
      user_id: '',
      nif: '',
      social_name: '',
      constitution_date: '',
      address: '',
      city: '',
      cp: '',
      province: '',
      region: '',
      country: '',
      phone: '',
      primary_activity: '',
      description: '',
      metas: [],
      user: {
        name: '',
        email: '',
        password: '',
      },
      meta_data: [],
      consultants: [],
      name: '',
      roles: [],
    };
  },
};
